import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Menu, Tooltip, useClipboard } from "@components/mantine";
import { CheckSize16Px, CopySize16Px } from "@coveord/plasma-react-icons";
import { useState } from "react";
import { Locales } from "../../../strings/Locales.js";
import { useSourceIdentityContext } from "../SourceIdentityContext.js";
// @todo: [CTCORE-10031] Enhance PLasma's CopyToClipboard component with an optional drop-down menu
export var SourceIdentityCopyInfoButton = function(param) {
    var trackCopyInfoButton = param.trackCopyInfoButton;
    var ref = useSourceIdentityContext(), id = ref.id, name = ref.name;
    var ref1 = _sliced_to_array(useState(false), 2), opened = ref1[0], setOpened = ref1[1];
    var ref2 = _sliced_to_array(useState(null), 2), lastCopiedValue = ref2[0], setLastCopiedValue = ref2[1];
    var clipboard = useClipboard({
        timeout: 2000
    });
    if (!id || !name) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Menu, {
        opened: opened,
        onChange: setOpened,
        withinPortal: true,
        children: [
            /*#__PURE__*/ _jsx(Menu.Target, {
                children: clipboard.copied ? /*#__PURE__*/ _jsx(Tooltip, {
                    label: Locales.format("SourceIdentity.CopyInfoButton.tooltip.copied.".concat(lastCopiedValue)),
                    opened: clipboard.copied,
                    children: /*#__PURE__*/ _jsx(ActionIcon.Secondary, {
                        mih: 0,
                        h: 16,
                        color: "success",
                        children: /*#__PURE__*/ _jsx(CheckSize16Px, {
                            height: 16
                        })
                    })
                }, "copied-tooltip") : /*#__PURE__*/ _jsx(Tooltip, {
                    label: Locales.format("SourceIdentity.CopyInfoButton.tooltip"),
                    children: /*#__PURE__*/ _jsx(ActionIcon.Secondary, {
                        mih: 0,
                        h: 16,
                        className: "copy-button",
                        "data-opened-menu": opened,
                        onClick: function(event) {
                            event.stopPropagation();
                            setOpened(true);
                        },
                        children: /*#__PURE__*/ _jsx(CopySize16Px, {
                            height: 16
                        })
                    })
                }, "hover-tooltip")
            }),
            /*#__PURE__*/ _jsxs(Menu.Dropdown, {
                children: [
                    /*#__PURE__*/ _jsx(Menu.Item, {
                        onClick: function(event) {
                            event.stopPropagation();
                            clipboard.copy(name);
                            setLastCopiedValue("name");
                            trackCopyInfoButton === null || trackCopyInfoButton === void 0 ? void 0 : trackCopyInfoButton("name to clipboard", id);
                        },
                        p: "sm",
                        children: Locales.format("SourceIdentity.CopyInfoButton.label.name")
                    }),
                    /*#__PURE__*/ _jsx(Menu.Item, {
                        onClick: function(event) {
                            event.stopPropagation();
                            clipboard.copy(id);
                            setLastCopiedValue("id");
                            trackCopyInfoButton === null || trackCopyInfoButton === void 0 ? void 0 : trackCopyInfoButton("source id to clipboard", id);
                        },
                        p: "sm",
                        children: Locales.format("SourceIdentity.CopyInfoButton.label.id")
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=SourceIdentityCopyInfoButton.js.map